import ContainerTopNestedMenuItems from "../input/ContainerTopNestedMemuItems";
import TopMenuLayout from "../layout/TopMenuLayout";
import TopMenuItem from "./TopMenuItem";

function TopMenu({ menuItems }) {
  const topLevelItems = menuItems
    .filter(item => !item.parentTopMenuItemId)
    .sort((a, b) => a.order - b.order);

    return (
      <TopMenuLayout>
        {topLevelItems.map(item => {
          const key = item.topMenuItemId;
    
          if (item.menuType === "container") {
            return (
              <ContainerTopNestedMenuItems
                key={key}
                containerMenuItem={item}
                menuItems={menuItems}
              />
            );
          }
    
          return <TopMenuItem key={key} menuItem={item} />;
        })}
      </TopMenuLayout>
    );
    
}

export default TopMenu;
